/* global Swiper, windowWidth, breakpointSm */
// **********************************************************
// Fake container
// **********************************************************

const eventSliderOffset = () => {
  if (windowWidth() >= breakpointSm) {
    const eventSliders = document.querySelectorAll('.event-slider');

    eventSliders.forEach((eventSlider) => {
      const mainContainer = eventSlider.querySelector('.event-slider-js');

      const containerOffset = mainContainer.getBoundingClientRect().left;
      const containerOffsetNum = Math.trunc(containerOffset);

      const eventSliderContainer = eventSlider.querySelector('.event-slider-container');
      eventSliderContainer.style.left = `${containerOffsetNum}px`;
      eventSliderContainer.style.width = `calc(100% - ${containerOffsetNum}px)`;
    });
  }
};

eventSliderOffset();
window.addEventListener('resize', eventSliderOffset);

// **********************************************************
// Event slider
// **********************************************************
const eventSliderElements = document.querySelectorAll('[data-slider="event-slider"]');
const eventSliderOptions = {
  slidesPerView: 'auto',
  freeMode: true,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
};

eventSliderElements.forEach((el) => {
  const eventSliderParent = el.closest('.sc-event-slider');
  const arrowRight = eventSliderParent.querySelector('.arrow-right');
  const arrowLeft = eventSliderParent.querySelector('.arrow-left');
  eventSliderOptions.navigation.nextEl = arrowRight;
  eventSliderOptions.navigation.prevEl = arrowLeft;
  // eslint-disable-next-line no-new
  new Swiper(el, eventSliderOptions);
});
